// ============================================================================
// 📁 FILE: src/modules/ticket/components/detail/ClassificationBlock.js
// ============================================================================

import React from "react";

export default function ClassificationBlock({ ticket }) {
  if (!ticket) return null;

  const formatDate = (dt) => {
    if (!dt) return "-";
    try {
      return new Date(dt).toLocaleString();
    } catch {
      return dt;
    }
  };

  const Row = ({ label, value }) => (
    <div className="tf-info-row">
      <span className="label">{label}:</span>
      <span className="value">{value || "-"}</span>
    </div>
  );

  return (
    <div className="tf-block">
      <div className="tf-block-title">Classification</div>

      <Row label="Ticket Type" value={ticket.ticket_type?.name} />
      <Row label="Category" value={ticket.category?.name} />
      <Row label="Customer" value={ticket.reported_customer?.name} />
      <Row label="Created At" value={formatDate(ticket.created_at)} />
      <Row label="Updated At" value={formatDate(ticket.updated_at)} />
    </div>
  );
}
